import { render } from "./ReplyPost.vue?vue&type=template&id=b0448b2a&ts=true"
import script from "./ReplyPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyPost.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyPost.vue?vue&type=style&index=0&id=b0448b2a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0448b2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0448b2a', __exports__)) {
    api.reload('b0448b2a', __exports__)
  }
  
  module.hot.accept("./ReplyPost.vue?vue&type=template&id=b0448b2a&ts=true", () => {
    api.rerender('b0448b2a', render)
  })

}


export default __exports__